export default "__VITE_ASSET__CNoEf$Ox__"